import { ReactComponent as RemoveEntitySvg } from "../../assets/images/svgs/removeEntity.svg";

const RemoveEntityIcon = ({ className = "", ...props }) => {
  return (
    <RemoveEntitySvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default RemoveEntityIcon;
